/**
 * Central mapping of court_type values → Greek labels.
 * Shared by all components that display court information.
 */

export const COURT_TYPE_LABELS = {
  // Πολιτικά
  'single_peace': 'Μονομελές Ειρηνοδικείο',
  'multi_peace': 'Πολυμελές Ειρηνοδικείο',
  'peace_court': 'Ειρηνοδικείο',
  'single_first': 'Μονομελές Πρωτοδικείο',
  'multi_first': 'Πολυμελές Πρωτοδικείο',
  'single_appeal': 'Μονομελές Εφετείο',
  'multi_appeal': 'Τριμελές Εφετείο',
  'triple_appeal': 'Τριμελές Εφετείο',
  'supreme': 'Άρειος Πάγος',
  // Διοικητικά
  'single_admin_first': 'Μονομελές Διοικητικό Πρωτοδικείο',
  'triple_admin_first': 'Τριμελές Διοικητικό Πρωτοδικείο',
  'administrative_first': 'Διοικητικό Πρωτοδικείο',
  'admin_appeal': 'Διοικητικό Εφετείο',
  'administrative_appeal': 'Διοικητικό Εφετείο',
  'triple_admin_appeal': 'Τριμελές Διοικητικό Εφετείο',
  'council_of_state': 'Συμβούλιο της Επικρατείας',
  // Ποινικά
  'single_criminal': 'Μονομελές Πλημμελειοδικείο',
  'three_criminal': 'Τριμελές Πλημμελειοδικείο',
  'single_criminal_appeal': 'Μονομελές Εφετείο Κακουργημάτων',
  'triple_criminal_appeal': 'Τριμελές Εφετείο Κακουργημάτων',
  'five_criminal_appeal': 'Πενταμελές Εφετείο',
  'mixed_court': 'Μικτό Ορκωτό Δικαστήριο',
  'mixed_jury': 'Μικτό Ορκωτό',
  'appeal_criminal': 'Εφετείο Κακουργημάτων',
  'supreme_criminal': 'Άρειος Πάγος (Ποινικό)',
};

export const getCourtTypeLabel = (value) => {
  if (!value) return '';
  return COURT_TYPE_LABELS[value] || value;
};
